// extracted by mini-css-extract-plugin
export default {"formButton":"FormButton_formButton__v9ixo","multiColorButton":"FormButton_multiColorButton__a8i4H","whiteButton":"FormButton_whiteButton__qg8sA"};